import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useToken } from '@autobid/nuxt-auth/src/composables/useToken'
import { setUser } from '@sentry/nuxt'
import { watch } from 'vue'

export function useSetSentryUser() {
  const { isAuthed } = useAutobidAuth()
  const { tokenData } = useToken()

  const setSentryUser = () => {
    if (!isAuthed.value || !tokenData.value) {
      setUser(null)
      return
    }

    const { id, nickname: username } = tokenData.value
    setUser({ id, username })
  }

  watch(isAuthed, setSentryUser)

  return setSentryUser
}
